import React from "react";
import {
  CirclePlus
} from "lucide-react";

const OtherSkills = ({
  consLoisir,
  onChangeLoisir,
  handleClickLoisir,
  handleRemoveloisir,
}) => {
  return (
    <div className="card mb-grid">
      <div className="card-header">
        <div className="card-header-title">Autres compétences</div>
      </div>
      <div className="card-body">
        <form>
          <div className="form-group">
            <label className="form-label">Ajouter d'autres compétences</label>
            <input
              onChange={onChangeLoisir}
              className="form-control mb-2 input-credit-card"
              type="text"
              placeholder="Votre compétence"
            />
          </div>
          <button
            type="button"
            className="btn btn-primary mr-2"
            onClick={handleClickLoisir}
          >
            <CirclePlus />&nbsp;Ajouter
          </button>
        </form>
      </div>
    </div>
  );
};

export default OtherSkills;
